<template lang="pug">
    footer
        nav#footer-menu(v-if="items && items.length")
            tree-menu(:items="items" :max-depth="1" :allow-multiple-active-items="true" :delay="100")
        //- #va-footer
        //-     small.has-text-centered Erstellt mit CityPage, dem Webbaukasten der Vanameland
</template>

<script>

import _ from 'lodash'
import { mapGetters } from 'vuex'

import NestedSet from '@/nested-set-lib'

export default{
    name: 'Footer',
    computed: {
        items() {
            const menu = this.menus.find(menu => menu.key === 'footer-menu')
            let items = _.get(menu, 'menuItems') || []
            items = _.cloneDeep(items)

            if (items.length) {
                return NestedSet.createTree(items)
            }

            return items
        },
        ...mapGetters({
            menus: 'menus',
            config: 'config',
        })
    },
}
</script>

<style lang="sass" scoped>

    @import "~bulma/sass/utilities/mixins";

    footer ::v-deep
        nav#footer-menu
            display: none
            // font-weight: bold
            +desktop
                display: initial
                position: fixed
                bottom: 2rem
                right: 5rem
                z-index: 2
            ul
                & > li
                    border: 0
                    display: inline-block
                    & + li
                        &:before
                            content: "/"
                            margin: 0 6px
                    .tree-item
                        display: inline-block
        div#va-footer
            font-size: .8rem
            padding: 4px
            text-align: center
            background-color: rgba(0, 0, 0, .2)
            +desktop
                background-color: initial
                font-size: .9rem
                color: #4c4c4c
                width: 100%
                text-align: center
</style>
